import React from 'react';
import PieChart from '@components/pie-chart/pie-chart';
import SingleBar from '@components/single-bar/single-bar';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import VisualisationTable from '@components/visualisation-table/visualisation-table';
import { convertStringToFloat, generateKey } from '@utils/utils';
import { VisualisationBlockProps } from './visualisation-block.types';

const VisualisationBlock: React.FC<VisualisationBlockProps> = ({
  type,
  data,
  className,
}) => {
  switch (type) {
    case 'pie':
      return (
        <div className={className} data-testid="visualisation-pie-block">
          <VisualisationTable data={data} />
          <PieChart pieData={data} width="200" height="200" innerRadius="20" />
        </div>
      );
    case 'bar':
      return (
        <div className={className} data-testid="visualisation-bar-block">
          <VisualisationTable data={data} />
          <div className="bar-container">
            {data.map((datapoint, index) => (
              <SingleBar
                key={generateKey(datapoint.value, index)}
                displayVertical={false}
                target={0}
                value={convertStringToFloat(datapoint.value)}
                displayTitle={false}
              />
            ))}
          </div>
        </div>
      );
    default:
      console.warn(`Visualisation Block called with falsy prop. data: ${data}`);
      return null;
  }
};

const StyledVisualisationBlock = styled(VisualisationBlock)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${vars.spacingM} 0;
  height: 16rem;
  ${SingleBar} {
    width: 20rem;
    height: 2.5rem;
    margin: 0.6rem 0;
    .value-bar {
      height: 1rem;
      background: #3780c1bd;
    }
  }
`;

export default StyledVisualisationBlock;
